document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-aff]');
  if (!root) return;

  const screens = root.querySelectorAll('[data-aff-screen]');
  const progress = root.querySelector('[data-aff-progress]');
  const resetBtn = root.querySelector('[data-aff-reset]');
  const fitChoice = root.querySelector('[data-aff-fit-choice]');
  const productDataEl = root.querySelector('[data-aff-products]');
  const communityMetaobjectDataEl = root.querySelector('[data-aff-community-metaobjects]');
  const communityEntryEls = root.querySelectorAll('[data-aff-community-entry]');
  const runtimeDataEl = root.querySelector('[data-aff-runtime]');
  let runtimeData = { debugEnabled: false, communitySource: 'metaobjects' };
  try { runtimeData = runtimeDataEl ? JSON.parse(runtimeDataEl.textContent) : runtimeData; } catch (error) { console.warn('ALTOFF Fit Finder: runtime settings could not be read.', error); }

  function readCommunityJson(element, label) {
    if (!element) return [];
    try {
      const parsed = JSON.parse(element.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('ALTOFF Fit Finder: ' + label + ' could not be read.', error);
      return [];
    }
  }

  let productData = {};
  try {
    productData = productDataEl ? JSON.parse(productDataEl.textContent) : {};
  } catch (error) {
    console.error('ALTOFF Fit Finder: product data could not be read.', error);
  }

  function normalizeReferenceId(value) {
    const text = String(value == null ? '' : value).trim();
    const match = text.match(/(?:Product\/)?(\d+)(?:\D*)$/i);
    return match ? match[1] : text.toLowerCase();
  }

  function normalizeCommunityProduct(entry) {
    const explicit = String(entry && entry.product || '').trim().toLowerCase();
    if (explicit === 'aero' || explicit === 'summit') return explicit;

    const entryId = normalizeReferenceId(entry && entry.productId);
    if (entryId) {
      for (const key of ['aero', 'summit']) {
        const configuredId = normalizeReferenceId(productData[key] && productData[key].id);
        if (configuredId && configuredId === entryId) return key;
      }
    }

    const productText = [
      entry && entry.productTitle,
      entry && entry.productHandle,
      entry && entry.productUrl,
      entry && entry.productRaw,
      explicit
    ].filter(Boolean).join(' ').toLowerCase();
    if (productText.includes('aero') || productText.includes('active overalls')) return 'aero';
    if (productText.includes('summit shell') || productText.includes('summit-shell') || productText.includes('summit_shell')) return 'summit';

    for (const key of ['aero', 'summit']) {
      const configured = productData[key] || {};
      const candidates = [configured.title, configured.handle, configured.url].filter(Boolean).map((value) => String(value).toLowerCase());
      if (candidates.some((candidate) => candidate && productText.includes(candidate))) return key;
    }
    return '';
  }

  function communityPlaceholder(name) {
    const safeName = String(name || 'Community dog').replace(/[<>&"']/g, '').slice(0, 32);
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="900" viewBox="0 0 1200 900"><rect width="1200" height="900" fill="#f2f1ed"/><circle cx="600" cy="365" r="118" fill="#d8d6cf"/><path d="M330 790c28-176 136-270 270-270s242 94 270 270" fill="#d8d6cf"/><text x="600" y="842" text-anchor="middle" font-family="Arial,sans-serif" font-size="40" fill="#54524d">' + safeName + '</text></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  function normalizeCommunityEntries(entries) {
    const flattened = [];
    entries.forEach((entry) => {
      if (!entry || entry.visible === false) return;
      const product = normalizeCommunityProduct(entry);
      if (!product) {
        console.warn('ALTOFF Fit Finder: Community Dog loaded, but Product Worn could not yet be mapped. It remains available to the general gallery.', entry);
      }

      const shared = { ...entry, product: product || 'unmapped' };
      delete shared.photos;
      delete shared.coverImage;
      const photos = Array.isArray(entry.photos) ? entry.photos.filter((photo) => photo && photo.image) : [];
      const coverImage = entry.coverImage && entry.coverImage.image ? entry.coverImage : null;

      if (coverImage) {
        const matchingIndex = photos.findIndex((photo) => photo.image === coverImage.image || (coverImage.imageLarge && photo.imageLarge === coverImage.imageLarge));
        if (matchingIndex >= 0) photos[matchingIndex] = { ...photos[matchingIndex], isCover: true };
        else photos.unshift({ ...coverImage, isCover: true });
      }

      if (!photos.length && entry.image) photos.push({ image: entry.image, imageLarge: entry.imageLarge || entry.image, isCover: true });
      if (!photos.length) {
        const placeholder = communityPlaceholder(entry.dogName);
        photos.push({ image: placeholder, imageLarge: placeholder, isCover: true, isPlaceholder: true });
        console.warn('ALTOFF Fit Finder: Community Dog loaded without a readable image. A placeholder is shown.', entry);
      }

      photos.forEach((photo, index) => flattened.push({ ...shared, ...photo, isCover: photo.isCover === true || (!coverImage && index === 0) }));
    });
    return flattened.filter((item) => item && item.image);
  }

  const communityEntries = Array.from(communityEntryEls).reduce((entries, element, index) => {
    try {
      const parsed = JSON.parse(element.textContent);
      if (parsed && typeof parsed === 'object') entries.push(parsed);
    } catch (error) {
      console.warn('ALTOFF Fit Finder: Community Dog entry ' + (index + 1) + ' could not be read.', error, element.textContent);
    }
    return entries;
  }, []);

  // Backwards compatibility for Build 24.x, where the entries were one JSON array.
  if (!communityEntries.length && communityMetaobjectDataEl && communityMetaobjectDataEl.tagName === 'SCRIPT') {
    communityEntries.push(...readCommunityJson(communityMetaobjectDataEl, 'Community Dog Metaobjects'));
  }

  const fitGalleryData = normalizeCommunityEntries(communityEntries)
    .sort((a, b) => {
      const featuredDifference = Number(Boolean(b.featured)) - Number(Boolean(a.featured));
      if (featuredDifference) return featuredDifference;
      return Number(a.sortOrder || 9999) - Number(b.sortOrder || 9999);
    });
  const communitySource = 'metaobjects';

  let state = {
    product: null,
    recommendation: null,
    selectedVariant: null,
    optionSelections: {},
    measurements: null,
    activeProfileId: null,
    pendingWardrobeUpdate: null,
    galleryVisibleCount: 4
  };

  const profileStorageKey = 'altoffFitFinderDogProfilesV2';
  const analyticsStorageKey = 'altoffFitFinderAnalyticsV1';
  let analyticsEvents = loadAnalyticsEvents();
  let currentAudit = null;
  const legacyProfileStorageKey = 'altoffFitFinderDogProfilesV1';
  const customerDataEl = root.querySelector('[data-aff-customer]');
  let customerData = { signedIn: false, customerId: null, firstName: null };
  try { customerData = customerDataEl ? JSON.parse(customerDataEl.textContent) : customerData; } catch (error) { console.warn('ALTOFF Fit Finder: customer context could not be read.', error); }
  let dogProfiles = loadDogProfiles();

  const configDataEl = root.querySelector('[data-aff-config]');
  let productConfigs = {};
  try {
    productConfigs = configDataEl ? JSON.parse(configDataEl.textContent) : {};
  } catch (error) {
    console.error('ALTOFF Fit Finder: configuration could not be read.', error);
  }

  const measurementLabels = { back: 'Back length', chest: 'Chest', neck: 'Neck' };

  function validateProductConfig(key, config) {
    const errors = [];
    if (!config || typeof config !== 'object') errors.push('configuration is missing');
    if (!config || !config.name) errors.push('name is missing');
    if (!config || !Array.isArray(config.sizes) || !config.sizes.length) errors.push('size chart is missing');
    if (!config || !['back', 'chest', 'neck'].includes(config.primaryMeasurement)) errors.push('primary measurement is invalid');
    if (!config || !config.recommendationStrategy) errors.push('recommendation strategy is missing');

    (config && Array.isArray(config.sizes) ? config.sizes : []).forEach((size, index) => {
      ['size', 'backMin', 'backMax', 'chestMin', 'chestMax', 'neckMin', 'neckMax'].forEach((field) => {
        if (size[field] == null || size[field] === '') errors.push('size row ' + (index + 1) + ' is missing ' + field);
      });
    });

    if (errors.length) console.error('ALTOFF Fit Finder: invalid product configuration for "' + key + '":', errors);
    return errors;
  }

  const configErrors = Object.keys(productConfigs).reduce((all, key) => {
    const errors = validateProductConfig(key, productConfigs[key]);
    if (errors.length) all[key] = errors;
    return all;
  }, {});


  function show(screen, options = {}) {
    screens.forEach((item) => item.classList.toggle('aff__screen--active', item.dataset.affScreen === screen));
    const widths = { welcome: '25%', product: '50%', measurements: '75%', result: '100%' };
    progress.style.width = widths[screen] || '25%';
    resetBtn.hidden = screen === 'welcome';
    if (options.scroll !== false) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function nearest(sizes, value, key) {
    const min = key + 'Min';
    const max = key + 'Max';
    return sizes
      .map((size) => ({
        ...size,
        distance: value < size[min] ? size[min] - value : value > size[max] ? value - size[max] : 0
      }))
      .sort((a, b) => a.distance - b.distance)[0];
  }

  function findByPrimary(chart, value, preference) {
    const key = chart.primaryMeasurement;
    const minKey = key + 'Min';
    const maxKey = key + 'Max';
    const direct = chart.sizes.find((size) => value >= size[minKey] && value <= size[maxKey]);
    if (!direct) return nearest(chart.sizes, value, key);

    const index = chart.sizes.indexOf(direct);
    const boundaryRules = chart.boundaryPreferenceRules || {};
    if (boundaryRules[preference] === 'size-up' && value === direct[maxKey] && index < chart.sizes.length - 1) return chart.sizes[index + 1];
    if (boundaryRules[preference] === 'size-down' && value === direct[minKey] && index > 0) return chart.sizes[index - 1];
    return direct;
  }

  function weightedPriorityRecommend(chart, measurements) {
    const priorityKey = chart.primaryMeasurement;
    const priorityMin = priorityKey + 'Min';
    const priorityMax = priorityKey + 'Max';
    let candidates = chart.sizes.filter((size) => measurements[priorityKey] >= size[priorityMin] && measurements[priorityKey] <= size[priorityMax]);
    if (!candidates.length) candidates = chart.sizes;

    const coverageKey = chart.coverageMeasurement;
    if (coverageKey) {
      const coverageMax = coverageKey + 'Max';
      const candidatesWithCoverage = candidates.filter((size) => measurements[coverageKey] <= size[coverageMax]);
      if (candidatesWithCoverage.length) candidates = candidatesWithCoverage;
    }

    const scoringWeights = chart.recommendationWeights;
    const midpointKey = chart.midpointTieBreaker || priorityKey;
    return candidates
      .map((size) => ({
        ...size,
        score: Object.keys(scoringWeights).reduce((score, key) => {
          const inside = measurements[key] >= size[key + 'Min'] && measurements[key] <= size[key + 'Max'];
          return score + (inside ? scoringWeights[key] : 0);
        }, 0) - Math.abs(measurements[midpointKey] - (size[midpointKey + 'Min'] + size[midpointKey + 'Max']) / 2)
      }))
      .sort((a, b) => b.score - a.score)[0];
  }

  function measurementStatus(value, min, max) {
    if (value < min) return { status: 'outside', direction: 'below', distance: min - value };
    if (value > max) return { status: 'outside', direction: 'above', distance: value - max };
    const range = Math.max(max - min, 1);
    const edgeDistance = Math.min(value - min, max - value);
    return { status: edgeDistance <= Math.max(1, range * 0.12) ? 'edge' : 'inside', direction: null, distance: edgeDistance };
  }

  function explanation(label, value, min, max) {
    const result = measurementStatus(value, min, max);
    if (result.status === 'inside') return { tone: 'good', text: label + ' sits comfortably within the size range.' };
    if (result.status === 'edge') return { tone: 'watch', text: label + ' is close to the edge of the size range.' };
    return {
      tone: 'watch',
      text: label + ' is ' + result.direction + ' this size range, so contact us if your dog has an unusual build.'
    };
  }

  function measurementAssessment(value, min, max) {
    const status = measurementStatus(value, min, max);
    const range = Math.max(max - min, 1);
    const midpoint = (min + max) / 2;
    const normalizedDistance = Math.abs(value - midpoint) / (range / 2);
    let score = Math.max(0, Math.min(100, Math.round(100 - normalizedDistance * 42)));

    if (status.status === 'edge') score = Math.min(score, 76);
    if (status.status === 'outside') score = Math.max(20, Math.round(58 - (status.distance / range) * 55));

    return {
      ...status,
      score,
      label: status.status === 'inside' ? (score >= 86 ? 'Excellent' : 'Good') : status.status === 'edge' ? 'Near boundary' : 'Outside range'
    };
  }

  function recommendationInsights(config, best, measurements) {
    const chart = config;
    const priorityKey = config.primaryMeasurement;
    const labels = measurementLabels;
    const weights = config.confidenceWeights;

    const assessments = {
      back: measurementAssessment(measurements.back, best.backMin, best.backMax),
      chest: measurementAssessment(measurements.chest, best.chestMin, best.chestMax),
      neck: measurementAssessment(measurements.neck, best.neckMin, best.neckMax)
    };

    const confidenceScore = Math.round(Object.keys(weights).reduce((total, key) => total + assessments[key].score * weights[key], 0));
    const outsideCount = Object.values(assessments).filter((item) => item.status === 'outside').length;
    const edgeCount = Object.values(assessments).filter((item) => item.status === 'edge').length;
    let confidence;
    if (outsideCount === 0 && edgeCount === 0 && confidenceScore >= 84) confidence = { label: 'Excellent match', className: 'is-excellent' };
    else if (outsideCount <= 1 && confidenceScore >= 62) confidence = { label: 'Good match', className: 'is-good' };
    else confidence = { label: 'Between sizes', className: 'is-borderline' };

    const limitingKey = Object.keys(assessments).sort((a, b) => {
      const weightedA = assessments[a].score - (a === priorityKey ? 8 : 0);
      const weightedB = assessments[b].score - (b === priorityKey ? 8 : 0);
      return weightedA - weightedB;
    })[0];

    const index = chart.sizes.findIndex((size) => size.size === best.size);
    const primary = assessments[priorityKey];
    let alternative = null;
    if (primary.status === 'edge' || primary.status === 'outside') {
      const value = measurements[priorityKey];
      const min = best[priorityKey + 'Min'];
      const max = best[priorityKey + 'Max'];
      const direction = value <= min ? -1 : value >= max ? 1 : (value - min < max - value ? -1 : 1);
      alternative = chart.sizes[index + direction] || null;
    }

    return { assessments, confidenceScore, confidence, limitingKey, limitingLabel: labels[limitingKey], priorityKey, labels, alternative };
  }

  function normalizeSize(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/2XS/g, 'XXS')
      .replace(/EXTRA\s*EXTRA\s*SMALL/g, 'XXS')
      .replace(/EXTRA\s*SMALL/g, 'XS')
      .replace(/SMALL/g, 'S')
      .replace(/MEDIUM/g, 'M')
      .replace(/LARGE/g, 'L')
      .replace(/EXTRA\s*LARGE/g, 'XL');
  }

  function optionIndex(product, matcher) {
    return (product.options || []).findIndex((name) => matcher.test(String(name)));
  }

  function getVariantOption(variant, index) {
    return variant['option' + (index + 1)];
  }

  function uniqueOptionValues(product, index) {
    const values = [];
    (product.variants || []).forEach((variant) => {
      const value = getVariantOption(variant, index);
      if (value != null && value !== '' && !values.includes(value)) values.push(value);
    });
    return values;
  }

  function variantMatchesSelections(variant, selections, ignoredIndex) {
    return Object.keys(selections).every((key) => {
      const index = Number(key);
      return index === ignoredIndex || getVariantOption(variant, index) === selections[index];
    });
  }

  function matchingVariants(product, selections) {
    return product.variants.filter((variant) => variantMatchesSelections(variant, selections));
  }

  function optionValueState(product, selections, optionIndexValue, optionValue) {
    const candidateSelections = { ...selections, [optionIndexValue]: optionValue };
    const candidates = matchingVariants(product, candidateSelections);
    return {
      exists: candidates.length > 0,
      available: candidates.some((variant) => variant.available)
    };
  }

  function selectedOptionsSummary(product, variant) {
    return (product.options || [])
      .map((name, index) => name + ': ' + getVariantOption(variant, index))
      .join(' · ');
  }

  function updatePurchaseProduct(product, variant) {
    const preview = root.querySelector('[data-aff-purchase-product]');
    const imageWrap = root.querySelector('[data-aff-purchase-image-wrap]');
    const image = root.querySelector('[data-aff-purchase-image]');
    const resultVisual = root.querySelector('[data-aff-result-visual]');
    const resultImage = root.querySelector('[data-aff-result-image]');
    const title = root.querySelector('[data-aff-purchase-title]');
    const price = root.querySelector('[data-aff-purchase-price]');

    if (!product || !variant) {
      preview.hidden = true;
      imageWrap.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      resultVisual.hidden = true;
      resultImage.removeAttribute('src');
      resultImage.alt = '';
      title.textContent = '';
      price.innerHTML = '';
      return;
    }

    preview.hidden = false;
    title.textContent = product.title || '';
    price.innerHTML = variant.compareAtPrice
      ? '<s>' + escapeHtml(variant.compareAtPrice) + '</s><span>' + escapeHtml(variant.price) + '</span>'
      : '<span>' + escapeHtml(variant.price || '') + '</span>';

    if (variant.image) {
      const imageAlt = (product.title || '') + ' — ' + (variant.title || 'selected variant');
      image.src = variant.image;
      image.alt = imageAlt;
      imageWrap.hidden = false;
      resultImage.src = variant.image;
      resultImage.alt = imageAlt;
      resultVisual.hidden = false;
    } else {
      imageWrap.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      resultVisual.hidden = true;
      resultImage.removeAttribute('src');
      resultImage.alt = '';
    }
  }

  function autoSelectForcedOptions(product, sizeIndex) {
    let changed = false;

    (product.options || []).forEach((_, optionIndexValue) => {
      if (optionIndexValue === sizeIndex || state.optionSelections[optionIndexValue] != null) return;

      const availableValues = uniqueOptionValues(product, optionIndexValue).filter((value) =>
        optionValueState(product, state.optionSelections, optionIndexValue, value).available
      );

      if (availableValues.length === 1) {
        state.optionSelections[optionIndexValue] = availableValues[0];
        changed = true;
      }
    });

    return changed;
  }

  function setupPurchase() {
    const pickerEl = root.querySelector('[data-aff-variant-picker]');
    const noteEl = root.querySelector('[data-aff-purchase-note]');
    const addButton = root.querySelector('[data-aff-add-cart]');
    const success = root.querySelector('[data-aff-cart-success]');

    pickerEl.innerHTML = '';
    noteEl.textContent = '';
    noteEl.removeAttribute('role');
    updatePurchaseProduct(null, null);
    addButton.disabled = true;
    addButton.textContent = 'Select your options';
    addButton.hidden = false;
    success.hidden = true;
    state.selectedVariant = null;
    state.optionSelections = {};

    const product = productData[state.product];
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      noteEl.innerHTML = 'Shopping is not connected yet. In the Theme Editor, select the matching Shopify product under <strong>Shopping setup</strong>.';
      return;
    }

    const sizeIndex = optionIndex(product, /size/i);
    if (sizeIndex < 0) {
      noteEl.textContent = 'We could not identify the Size option for this product. Rename the relevant Shopify option to include “Size”.';
      return;
    }

    const recommendedSizeValue = uniqueOptionValues(product, sizeIndex).find(
      (value) => normalizeSize(value) === normalizeSize(state.recommendation.size)
    );

    if (!recommendedSizeValue) {
      noteEl.textContent = 'No Shopify variant matched size ' + state.recommendation.size + '. Check that the product uses the same size labels.';
      return;
    }

    state.optionSelections[sizeIndex] = recommendedSizeValue;
    autoSelectForcedOptions(product, sizeIndex);
    renderVariantPicker();
  }

  function renderVariantPicker() {
    const product = productData[state.product];
    const pickerEl = root.querySelector('[data-aff-variant-picker]');
    const noteEl = root.querySelector('[data-aff-purchase-note]');
    const addButton = root.querySelector('[data-aff-add-cart]');
    const sizeIndex = optionIndex(product, /size/i);

    pickerEl.innerHTML = '';

    (product.options || []).forEach((optionName, optionIndexValue) => {
      const group = document.createElement('fieldset');
      group.className = 'aff__option-group';

      const legend = document.createElement('legend');
      legend.className = 'aff__option-label';
      legend.textContent = optionName;
      group.appendChild(legend);

      const valuesEl = document.createElement('div');
      valuesEl.className = 'aff__option-values';

      uniqueOptionValues(product, optionIndexValue).forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'aff__option-value';
        button.dataset.optionIndex = optionIndexValue;
        button.dataset.optionValue = value;

        const isSize = optionIndexValue === sizeIndex;
        const valueState = optionValueState(product, state.optionSelections, optionIndexValue, value);
        const isSelected = state.optionSelections[optionIndexValue] === value;

        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-sold-out', valueState.exists && !valueState.available);
        button.disabled = isSize || !valueState.exists || !valueState.available;
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        button.innerHTML = '<span>' + escapeHtml(value) + '</span>' +
          (isSize ? '<small>Recommended</small>' : !valueState.exists ? '<small>Unavailable</small>' : !valueState.available ? '<small>Sold out</small>' : '');

        if (!isSize) {
          button.addEventListener('click', () => {
            state.optionSelections[optionIndexValue] = value;
            state.selectedVariant = null;
            autoSelectForcedOptions(product, sizeIndex);
            renderVariantPicker();
          });
        }
        valuesEl.appendChild(button);
      });

      group.appendChild(valuesEl);
      pickerEl.appendChild(group);
    });

    const allOptionsSelected = (product.options || []).every((_, index) => state.optionSelections[index] != null);
    const exactMatches = allOptionsSelected ? matchingVariants(product, state.optionSelections) : [];
    const exactVariant = exactMatches.find((variant) => variant.available) || exactMatches[0] || null;

    if (!allOptionsSelected) {
      const remaining = product.options.filter((_, index) => state.optionSelections[index] == null);
      state.selectedVariant = null;
      updatePurchaseProduct(product, matchingVariants(product, state.optionSelections).find((variant) => variant.available) || null);
      addButton.disabled = true;
      addButton.textContent = 'Choose ' + remaining.join(' and ');
      noteEl.removeAttribute('role');
      noteEl.textContent = '';
      return;
    }

    if (!exactVariant || !exactVariant.available) {
      state.selectedVariant = null;
      updatePurchaseProduct(product, exactVariant);
      addButton.disabled = true;
      addButton.textContent = 'Selected combination sold out';
      noteEl.setAttribute('role', 'alert');
      noteEl.textContent = 'This combination is currently unavailable. Choose another option.';
      return;
    }

    const previousVariantId = state.selectedVariant && state.selectedVariant.id;
    state.selectedVariant = exactVariant;
    if (previousVariantId !== exactVariant.id) {
      recordAnalyticsEvent('variant_selected', { variantId: exactVariant.id, variantTitle: exactVariant.title, recommendedSize: state.recommendation ? state.recommendation.size : null });
    }
    updatePurchaseProduct(product, exactVariant);
    renderDebugAudit();
    addButton.disabled = false;
    addButton.textContent = 'Add to cart';
    noteEl.removeAttribute('role');
    noteEl.textContent = selectedOptionsSummary(product, exactVariant);
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function normalizeProfile(profile) {
    if (!profile || !profile.id || !profile.name || !validMeasurements(profile.measurements)) return null;
    return {
      id: String(profile.id),
      version: 2,
      name: String(profile.name).slice(0, 40),
      measurements: {
        back: Number(profile.measurements.back),
        chest: Number(profile.measurements.chest),
        neck: Number(profile.measurements.neck)
      },
      fitPreference: profile.fitPreference || null,
      recommendationHistory: Array.isArray(profile.recommendationHistory) ? profile.recommendationHistory.slice(0, 12) : [],
      createdAt: profile.createdAt || profile.updatedAt || new Date().toISOString(),
      updatedAt: profile.updatedAt || new Date().toISOString(),
      localOwnerKey: profile.localOwnerKey || (customerData.signedIn && customerData.customerId ? 'customer:' + customerData.customerId : 'guest')
    };
  }

  function loadDogProfiles() {
    try {
      let raw = window.localStorage.getItem(profileStorageKey);
      if (!raw) raw = window.localStorage.getItem(legacyProfileStorageKey);
      const stored = JSON.parse(raw || '[]');
      const normalized = Array.isArray(stored) ? stored.map(normalizeProfile).filter(Boolean) : [];
      if (normalized.length) window.localStorage.setItem(profileStorageKey, JSON.stringify(normalized));
      return normalized;
    } catch (error) {
      console.warn('ALTOFF Fit Finder: saved dog profiles could not be read.', error);
      return [];
    }
  }

  function persistDogProfiles() {
    try {
      window.localStorage.setItem(profileStorageKey, JSON.stringify(dogProfiles));
      return true;
    } catch (error) {
      console.warn('ALTOFF Fit Finder: dog profiles could not be saved.', error);
      alert('This browser could not save the dog profile. Please check that private browsing or storage restrictions are disabled.');
      return false;
    }
  }

  function createProfileId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'dog-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function currentMeasurements() {
    return {
      back: Number(root.querySelector('#aff-back').value),
      chest: Number(root.querySelector('#aff-chest').value),
      neck: Number(root.querySelector('#aff-neck').value)
    };
  }

  function validMeasurements(measurements) {
    return measurements && measurements.back > 0 && measurements.chest > 0 && measurements.neck > 0;
  }

  function latestRecommendation(profile) {
    return profile && Array.isArray(profile.recommendationHistory) && profile.recommendationHistory.length ? profile.recommendationHistory[0] : null;
  }

  function latestRecommendationForProduct(profile, productKey) {
    if (!profile || !productKey || !Array.isArray(profile.recommendationHistory)) return null;
    return profile.recommendationHistory.find((item) => item.productKey === productKey) || null;
  }

  function renderSavedFitRecall() {
    const section = root.querySelector('[data-aff-saved-fit]');
    const title = root.querySelector('[data-aff-saved-fit-title]');
    const copy = root.querySelector('[data-aff-saved-fit-copy]');
    const check = root.querySelector('[data-aff-saved-fit-check]');
    const profile = dogProfiles.find((item) => item.id === state.activeProfileId);
    const chart = productConfigs[state.product];
    if (!section || !title || !copy || !check || !profile || !chart) {
      if (section) section.hidden = true;
      return;
    }
    const saved = latestRecommendationForProduct(profile, state.product);
    title.textContent = profile.name + '’s ' + chart.shortName + ' fit';
    if (saved) {
      copy.textContent = 'Previously recommended Size ' + saved.size + '. Saved measurements are loaded below.';
      check.textContent = 'Check Size ' + saved.size + ' again';
    } else {
      copy.textContent = 'Saved measurements are loaded. Check the best size for ' + chart.shortName + '.';
      check.textContent = 'Check ' + chart.shortName + ' size';
    }
    section.hidden = false;
  }

  function renderProfiles() {
    const list = root.querySelector('[data-aff-profile-list]');
    const empty = root.querySelector('[data-aff-profile-empty]');
    if (!list || !empty) return;
    list.innerHTML = dogProfiles.map((profile) => {
      const activeClass = profile.id === state.activeProfileId ? ' is-active' : '';
      const latest = latestRecommendationForProduct(profile, state.product) || latestRecommendation(profile);
      const recommendation = latest ? '<span class="aff__profile-recommendation">' + escapeHtml(latest.productName) + ' · Size ' + escapeHtml(latest.size) + '</span>' : '<span class="aff__profile-recommendation">Use saved measurements</span>';
      return '<div class="aff__profile-chip' + activeClass + '" data-aff-profile-id="' + escapeHtml(profile.id) + '">' +
        '<button type="button" data-aff-profile-use="' + escapeHtml(profile.id) + '" class="aff__profile-use">' +
        '<strong>' + escapeHtml(profile.name) + '</strong><span>' + profile.measurements.back + ' / ' + profile.measurements.chest + ' / ' + profile.measurements.neck + ' cm</span>' + recommendation + '</button>' +
        '<div class="aff__profile-chip-actions"><button type="button" data-aff-profile-edit="' + escapeHtml(profile.id) + '">Edit</button><button type="button" data-aff-profile-delete="' + escapeHtml(profile.id) + '">Remove</button></div></div>';
    }).join('');
    empty.hidden = dogProfiles.length > 0;
    renderPassportHistory();
    renderSavedFitRecall();
  }

  function renderPassportHistory() {
    const section = root.querySelector('[data-aff-passport-history]');
    const list = root.querySelector('[data-aff-history-list]');
    const title = root.querySelector('[data-aff-history-title]');
    const updated = root.querySelector('[data-aff-wardrobe-updated]');
    const profile = dogProfiles.find((item) => item.id === state.activeProfileId);
    const history = profile && Array.isArray(profile.recommendationHistory) ? profile.recommendationHistory : [];
    if (!section || !list || !title || !profile || !history.length) {
      if (section) section.hidden = true;
      return;
    }

    // Recommendation history remains available internally, but the customer-facing
    // Dog Passport shows only the latest saved size for each product.
    const currentByProduct = [];
    const seenProducts = new Set();
    history.forEach((item) => {
      const productKey = String(item.productId || item.productHandle || item.productName || '').trim().toLowerCase();
      if (!productKey || seenProducts.has(productKey)) return;
      seenProducts.add(productKey);
      currentByProduct.push(item);
    });

    if (!currentByProduct.length) {
      section.hidden = true;
      return;
    }

    title.textContent = profile.name + '’s current wardrobe';
    list.innerHTML = currentByProduct.map((item) =>
      '<div class="aff__history-item aff__wardrobe-item"><strong>' + escapeHtml(item.productName) + '</strong><b>Size ' + escapeHtml(item.size) + '</b></div>'
    ).join('');

    const latestDate = history[0] && history[0].createdAt ? new Date(history[0].createdAt) : null;
    if (updated && latestDate && !Number.isNaN(latestDate.getTime())) {
      updated.textContent = 'Last updated ' + latestDate.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
      updated.hidden = false;
    } else if (updated) {
      updated.hidden = true;
    }
    section.hidden = false;
  }

  function applyProfile(profile) {
    if (!profile || !validMeasurements(profile.measurements)) return;
    state.activeProfileId = profile.id;
    ['back', 'chest', 'neck'].forEach((key) => {
      const input = root.querySelector('#aff-' + key);
      input.value = profile.measurements[key];
      const card = root.querySelector('[data-aff-card="' + key + '"]');
      if (card) card.classList.add('is-complete');
    });
    if (profile.fitPreference) {
      const fitInput = root.querySelector('input[name="aff-fit"][value="' + profile.fitPreference + '"]');
      if (fitInput) fitInput.checked = true;
    }
    renderProfiles();
    renderSavedFitRecall();
  }

  function openProfileSheet(profile) {
    const measurements = profile ? profile.measurements : (state.measurements || currentMeasurements());
    if (!validMeasurements(measurements)) {
      alert('Enter all three measurements before saving a dog profile.');
      return;
    }
    const sheet = root.querySelector('[data-aff-profile-sheet]');
    const nameInput = root.querySelector('[data-aff-profile-name]');
    sheet.dataset.profileId = profile ? profile.id : '';
    root.querySelector('[data-aff-profile-heading]').textContent = profile ? 'Edit dog profile' : 'Save measurements';
    root.querySelector('[data-aff-profile-confirm]').textContent = profile ? 'Update profile' : 'Save profile';
    nameInput.value = profile ? profile.name : '';
    root.querySelector('[data-aff-profile-preview]').innerHTML = ['back', 'chest', 'neck'].map((key) =>
      '<div><strong>' + escapeHtml(measurements[key] + ' cm') + '</strong><span>' + escapeHtml(measurementLabels[key]) + '</span></div>'
    ).join('');
    sheet.dataset.measurements = JSON.stringify(measurements);
    root.classList.add('is-profile-open');
    sheet.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => nameInput.focus(), 100);
  }

  function closeProfileSheet() {
    const sheet = root.querySelector('[data-aff-profile-sheet]');
    root.classList.remove('is-profile-open');
    sheet.setAttribute('aria-hidden', 'true');
  }

  function saveProfileFromSheet() {
    const sheet = root.querySelector('[data-aff-profile-sheet]');
    const name = root.querySelector('[data-aff-profile-name]').value.trim();
    if (!name) {
      alert('Please enter your dog’s name.');
      return;
    }
    let measurements;
    try { measurements = JSON.parse(sheet.dataset.measurements || '{}'); } catch (error) { measurements = null; }
    if (!validMeasurements(measurements)) return;
    const existingId = sheet.dataset.profileId;
    const fitInput = root.querySelector('input[name="aff-fit"]:checked');
    const existingProfile = dogProfiles.find((item) => item.id === existingId);
    const profile = {
      id: existingId || createProfileId(),
      version: 2,
      name: name.slice(0, 40),
      measurements,
      fitPreference: fitInput ? fitInput.value : null,
      recommendationHistory: existingProfile && Array.isArray(existingProfile.recommendationHistory) ? existingProfile.recommendationHistory : [],
      createdAt: existingProfile ? existingProfile.createdAt : new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      localOwnerKey: customerData.signedIn && customerData.customerId ? 'customer:' + customerData.customerId : 'guest'
    };
    const existingIndex = dogProfiles.findIndex((item) => item.id === profile.id);
    if (existingIndex >= 0) dogProfiles[existingIndex] = profile;
    else dogProfiles.unshift(profile);
    dogProfiles = dogProfiles.slice(0, 8);
    if (!persistDogProfiles()) return;
    state.activeProfileId = profile.id;
    state.measurements = measurements;
    renderProfiles();
    updateProfileSaveCard();
    closeProfileSheet();
  }

  function updateProfileSaveCard() {
    const active = dogProfiles.find((profile) => profile.id === state.activeProfileId);
    const title = root.querySelector('[data-aff-profile-save-title]');
    const copy = root.querySelector('[data-aff-profile-save-copy]');
    const button = root.querySelector('[data-aff-profile-save]');
    if (!title || !copy || !button) return;
    if (active) {
      title.textContent = active.name + ' is saved';
      copy.textContent = 'Update this profile whenever the measurements change.';
      button.textContent = 'Update ' + active.name;
    } else {
      title.textContent = 'Save these measurements';
      copy.textContent = 'Keep this dog’s measurements on this device so you can get future recommendations faster.';
      button.textContent = 'Save dog profile';
    }
  }

  function loadAnalyticsEvents() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(analyticsStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed.slice(0, 150) : [];
    } catch (error) {
      return [];
    }
  }

  function recordAnalyticsEvent(type, payload) {
    const event = {
      schemaVersion: 1,
      id: type + ':' + Date.now() + ':' + Math.random().toString(36).slice(2, 7),
      type,
      productKey: state.product,
      profileId: state.activeProfileId || null,
      createdAt: new Date().toISOString(),
      ...payload
    };
    analyticsEvents = [event, ...analyticsEvents].slice(0, 150);
    try { window.localStorage.setItem(analyticsStorageKey, JSON.stringify(analyticsEvents)); } catch (error) { /* non-blocking */ }
    return event;
  }

  function renderFitIntelligence(chart, best, measurements) {
    const section = root.querySelector('[data-aff-fit-intelligence]');
    const grid = root.querySelector('[data-aff-fit-intelligence-grid]');
    if (!section || !grid) return;

    const referenceMatches = galleryDogs(state.product)
      .map((item) => ({ ...item, similarityScore: gallerySimilarityScore(item, best.size, measurements) }))
      .sort((a, b) => a.similarityScore - b.similarityScore)
      .slice(0, 8);
    const sameSizeReferences = referenceMatches.filter((item) => normalizeSize(item.size) === normalizeSize(best.size)).length;

    const cards = [];
    if (referenceMatches.length) {
      cards.push({ value: sameSizeReferences + '/' + referenceMatches.length, label: 'closest real-dog references wear Size ' + best.size });
    }

    if (!cards.length) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }
    grid.innerHTML = cards.slice(0, 3).map((card) => '<div><strong>' + escapeHtml(card.value) + '</strong><p>' + escapeHtml(card.label) + '</p></div>').join('');
    section.hidden = false;
  }

  function renderDebugAudit() {
    const panel = root.querySelector('[data-aff-debug]');
    const grid = root.querySelector('[data-aff-debug-grid]');
    if (!panel || !grid || !runtimeData.debugEnabled || !currentAudit) {
      if (panel) panel.hidden = true;
      return;
    }
    const rows = [
      ['Product configuration', currentAudit.productName],
      ['Strategy', currentAudit.strategy],
      ['Primary measurement', currentAudit.primaryMeasurement],
      ['Decision path', currentAudit.decisionPath.join(' → ')],
      ['Confidence', currentAudit.confidenceScore + '% · ' + currentAudit.confidenceLabel],
      ['Boundary alternative', currentAudit.alternative || 'None'],
      ['Selected variant', state.selectedVariant ? (state.selectedVariant.title || state.selectedVariant.id) : 'Not selected'],
      ['Community source', 'Unified Community Fit metaobjects'],
      ['Matched gallery records', String(currentAudit.galleryMatches)]
    ];
    grid.innerHTML = rows.map((row) => '<div><span>' + escapeHtml(row[0]) + '</span><strong>' + escapeHtml(row[1]) + '</strong></div>').join('');
    panel.hidden = false;
  }

  function saveRecommendationEntry(profileId, entry, measurements) {
    const index = dogProfiles.findIndex((profile) => profile.id === profileId);
    if (index < 0) return false;
    const profile = dogProfiles[index];
    const history = Array.isArray(profile.recommendationHistory) ? profile.recommendationHistory : [];
    const withoutDuplicate = history.filter((item) => !(item.productKey === entry.productKey && item.size === entry.size && JSON.stringify(item.measurements) === JSON.stringify(entry.measurements)));
    dogProfiles[index] = { ...profile, measurements: { ...measurements }, fitPreference: entry.fitPreference, recommendationHistory: [entry, ...withoutDuplicate].slice(0, 12), updatedAt: entry.createdAt };
    persistDogProfiles();
    renderProfiles();
    return true;
  }

  function hideSavedSizeConflict() {
    const section = root.querySelector('[data-aff-saved-size-conflict]');
    if (section) section.hidden = true;
    state.pendingWardrobeUpdate = null;
  }

  function renderSavedSizeConflict(profile, saved, entry, measurements) {
    const section = root.querySelector('[data-aff-saved-size-conflict]');
    if (!section) return;
    root.querySelector('[data-aff-conflict-title]').textContent = profile.name + '’s saved size is ' + saved.size;
    root.querySelector('[data-aff-conflict-copy]').textContent = 'Today’s measurements suggest Size ' + entry.size + '. Choose whether to keep the saved wardrobe size or update it.';
    root.querySelector('[data-aff-conflict-keep]').textContent = 'Keep Size ' + saved.size;
    root.querySelector('[data-aff-conflict-update]').textContent = 'Update to Size ' + entry.size;
    root.querySelector('[data-aff-conflict-contact]').href = root.querySelector('[data-aff-whatsapp]').href;
    state.pendingWardrobeUpdate = { profileId: profile.id, entry, measurements: { ...measurements }, savedSize: saved.size };
    section.hidden = false;
  }

  function recordRecommendation(profileId, chart, best, confidence, preference, measurements) {
    hideSavedSizeConflict();
    if (!profileId) return;
    const profile = dogProfiles.find((item) => item.id === profileId);
    if (!profile) return;
    const entry = {
      id: state.product + ':' + best.size + ':' + Date.now(),
      productKey: state.product,
      productName: chart.name,
      size: best.size,
      confidence: confidence.label,
      fitPreference: preference || chart.defaultFitPreference || null,
      measurements: { ...measurements },
      createdAt: new Date().toISOString()
    };
    const saved = latestRecommendationForProduct(profile, state.product);
    if (saved && normalizeSize(saved.size) !== normalizeSize(entry.size)) {
      renderSavedSizeConflict(profile, saved, entry, measurements);
      recordAnalyticsEvent('saved_size_conflict', { savedSize: saved.size, recommendedSize: entry.size });
      return;
    }
    saveRecommendationEntry(profileId, entry, measurements);
  }

  async function addToCart() {
    if (!state.selectedVariant) return;
    const button = root.querySelector('[data-aff-add-cart]');
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(state.selectedVariant.id), quantity: 1 }] })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');

      recordAnalyticsEvent('add_to_cart', {
        variantId: state.selectedVariant.id,
        variantTitle: state.selectedVariant.title,
        recommendedSize: state.recommendation ? state.recommendation.size : null,
        measurements: state.measurements ? { ...state.measurements } : null
      });
      button.hidden = true;
      const success = root.querySelector('[data-aff-cart-success]');
      root.querySelector('[data-aff-cart-summary]').textContent = selectedOptionsSummary(productData[state.product], state.selectedVariant);
      success.hidden = false;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      alert(error.message || 'Something went wrong. Please try again.');
    }
  }

  function numericGalleryValue(value) {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : null;
  }

  function communityBreedLabel(item) {
    return [item && item.sex, item && item.breed].filter(Boolean).join(' ');
  }

  function galleryDogs(productKey, options) {
    const settings = options || {};
    const groups = new Map();
    fitGalleryData
      .filter((item) => item.product === productKey || (settings.includeUnmapped && item.product === 'unmapped'))
      .forEach((item) => {
        const key = String(item.dogId || item.id) + '::' + item.product;
        if (!groups.has(key)) groups.set(key, { ...item, photos: [], dogKey: key });
        const dog = groups.get(key);
        dog.photos.push(item);
        ['dogName', 'breed', 'sex', 'size', 'colour', 'weight', 'back', 'chest', 'neck', 'caption', 'activityTag', 'instagramHandle', 'instagramUrl', 'verificationType', 'featured', 'sortOrder'].forEach((field) => {
          if ((!dog[field] && dog[field] !== 0) && (item[field] || item[field] === 0)) dog[field] = item[field];
        });
      });

    return Array.from(groups.values()).map((dog) => {
      const coverIndex = dog.photos.findIndex((photo) => photo.isCover);
      const orderedPhotos = coverIndex > 0
        ? [dog.photos[coverIndex], ...dog.photos.slice(0, coverIndex), ...dog.photos.slice(coverIndex + 1)]
        : dog.photos;
      const cover = orderedPhotos[0];
      return { ...dog, ...cover, photos: orderedPhotos, dogKey: dog.dogKey };
    }).sort((a, b) => {
      const featuredDifference = Number(Boolean(b.featured)) - Number(Boolean(a.featured));
      if (featuredDifference) return featuredDifference;
      return (numericGalleryValue(a.sortOrder) ?? 9999) - (numericGalleryValue(b.sortOrder) ?? 9999);
    });
  }

  function gallerySimilarityScore(item, recommendedSize, measurements) {
    let score = normalizeSize(item.size) === normalizeSize(recommendedSize) ? 0 : 80;
    const weights = { back: 1.15, chest: 1, neck: 0.8 };
    let comparableMeasurements = 0;

    ['back', 'chest', 'neck'].forEach((key) => {
      const reference = numericGalleryValue(item[key]);
      if (reference == null || measurements[key] == null) return;
      score += Math.abs(reference - measurements[key]) * weights[key];
      comparableMeasurements += 1;
    });

    if (!comparableMeasurements) score += 25;
    return score;
  }

  function galleryMatchPercentage(item, recommendedSize, measurements) {
    const tolerances = { back: 10, chest: 14, neck: 10 };
    const weights = { back: 1.15, chest: 1, neck: 0.8 };
    let weightedScore = 0;
    let totalWeight = 0;
    let comparableMeasurements = 0;

    ['back', 'chest', 'neck'].forEach((key) => {
      const reference = numericGalleryValue(item[key]);
      const entered = numericGalleryValue(measurements[key]);
      if (reference == null || entered == null) return;
      const dimensionScore = Math.max(0, 100 - (Math.abs(reference - entered) / tolerances[key]) * 100);
      weightedScore += dimensionScore * weights[key];
      totalWeight += weights[key];
      comparableMeasurements += 1;
    });

    if (!comparableMeasurements) return normalizeSize(item.size) === normalizeSize(recommendedSize) ? 62 : 30;

    const completeness = comparableMeasurements / 3;
    let score = weightedScore / totalWeight;
    score *= 0.72 + (0.28 * completeness);
    score += normalizeSize(item.size) === normalizeSize(recommendedSize) ? 8 : -30;
    return Math.max(0, Math.min(100, Math.round(score)));
  }

  function galleryMatchLabel(score) {
    if (score >= 90) return 'Excellent match';
    if (score >= 80) return 'Very similar';
    if (score >= 65) return 'Similar fit';
    return 'Useful reference';
  }

  function comparisonMeasurementRow(key, measurements, item) {
    const entered = numericGalleryValue(measurements[key]);
    const reference = numericGalleryValue(item[key]);
    if (entered == null || reference == null) return '';
    const difference = Math.round((reference - entered) * 10) / 10;
    const differenceCopy = difference === 0 ? 'same' : (difference > 0 ? '+' : '−') + Math.abs(difference) + ' cm';
    return '<div class="aff__fit-comparison-row" role="row">' +
      '<span role="rowheader">' + escapeHtml(measurementLabels[key]) + '</span>' +
      '<strong role="cell">' + escapeHtml(String(entered)) + ' cm</strong>' +
      '<strong role="cell">' + escapeHtml(String(reference)) + ' cm <small>' + escapeHtml(differenceCopy) + '</small></strong>' +
    '</div>';
  }

  function communityVerificationLabel(type) {
    return { customer: 'Verified customer', ambassador: 'ALTOFF ambassador', featured: 'Featured dog' }[type] || '';
  }

  function communitySocialMarkup(item, className) {
    const handle = String(item.instagramHandle || '').replace(/^@+/, '').trim();
    const url = String(item.instagramUrl || '').trim();
    const badge = communityVerificationLabel(item.verificationType);
    const parts = [];
    if (badge) parts.push('<span class="aff__community-badge">✓ ' + escapeHtml(badge) + '</span>');
    if (url) {
      const label = handle ? '@' + handle : 'View Instagram profile';
      parts.push('<a class="aff__community-instagram" href="' + escapeHtml(url) + '" target="_blank" rel="noopener noreferrer" aria-label="Open ' + escapeHtml(label) + ' on Instagram"><svg class="aff__instagram-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="4.1" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17.4" cy="6.7" r="1.15" fill="currentColor"/></svg><span>' + escapeHtml(label) + '</span></a>');
    } else if (handle) {
      parts.push('<span class="aff__community-instagram aff__community-instagram--plain">@' + escapeHtml(handle) + '</span>');
    }
    return parts.length ? '<div class="' + (className || 'aff__community-social') + '">' + parts.join('') + '</div>' : '';
  }

  function renderFitComparison(chart, best, measurements) {
    const section = root.querySelector('[data-aff-fit-comparison]');
    const grid = root.querySelector('[data-aff-fit-comparison-grid]');
    if (!section || !grid) return;

    const isEnabled = section.dataset.affEnabled !== 'false';
    const limit = Math.max(1, Math.min(5, Number.parseInt(section.dataset.affLimit, 10) || 3));
    const threshold = Math.max(0, Math.min(100, Number.parseInt(section.dataset.affThreshold, 10) || 55));
    if (!isEnabled) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }

    const matches = galleryDogs(state.product)
      .map((item) => ({
        ...item,
        matchPercentage: galleryMatchPercentage(item, best.size, measurements),
        similarityScore: gallerySimilarityScore(item, best.size, measurements),
        exactSizeMatch: normalizeSize(item.size) === normalizeSize(best.size) ? 1 : 0
      }))
      .filter((item) => item.matchPercentage >= threshold)
      .sort((a, b) => (b.exactSizeMatch - a.exactSizeMatch) || (b.matchPercentage - a.matchPercentage) || (a.similarityScore - b.similarityScore))
      .slice(0, limit);

    if (!matches.length) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }

    const activeProfile = dogProfiles.find((profile) => profile.id === state.activeProfileId);
    root.querySelector('[data-aff-fit-comparison-title]').textContent = activeProfile
      ? 'Dogs closest to ' + activeProfile.name + '’s measurements'
      : 'Dogs closest to your measurements';
    root.querySelector('[data-aff-fit-comparison-copy]').textContent = 'Real ALTOFF dogs ranked by recommended size and the measurements available.';
    root.querySelector('[data-aff-fit-comparison-count]').textContent = matches.length + (matches.length === 1 ? ' match' : ' matches');

    grid.innerHTML = matches.map((item, index) => {
      const name = item.dogName || 'ALTOFF dog';
      const meta = [communityBreedLabel(item), numericGalleryValue(item.weight) != null ? numericGalleryValue(item.weight) + ' kg' : ''].filter(Boolean).join(' · ');
      const variant = ['Size ' + item.size, item.colour].filter(Boolean).join(' · ');
      const rows = ['back', 'chest', 'neck'].map((key) => comparisonMeasurementRow(key, measurements, item)).join('');
      const comparisonDetails = rows
        ? '<div class="aff__fit-comparison-table" role="table" aria-label="Measurement comparison with ' + escapeHtml(name) + '">' +
            '<div class="aff__fit-comparison-row aff__fit-comparison-row--head" role="row"><span role="columnheader">Measurement</span><strong role="columnheader">Your dog</strong><strong role="columnheader">' + escapeHtml(name) + '</strong></div>' + rows +
          '</div>'
        : '<p class="aff__fit-comparison-unavailable">Measurements are not recorded for this reference yet.</p>';
      const photo = item.photos && item.photos.length ? item.photos[0] : item;
      const detailsId = 'aff-fit-comparison-details-' + index;
      return '<article class="aff__fit-comparison-card" data-aff-comparison-card data-aff-comparison-index="' + index + '">' +
        '<button class="aff__fit-comparison-photo" type="button" data-aff-comparison-open aria-label="View photos of ' + escapeHtml(name) + '">' +
          '<img src="' + escapeHtml(photo.image) + '" alt="' + escapeHtml(name + ' wearing ' + chart.shortName + ' in size ' + item.size) + '" loading="lazy">' +
          '<span class="aff__fit-comparison-badge"><strong>' + item.matchPercentage + '%</strong>' + escapeHtml(galleryMatchLabel(item.matchPercentage)) + '</span>' +
        '</button>' +
        '<div class="aff__fit-comparison-copy">' +
          '<div class="aff__fit-comparison-summary">' +
            '<div><strong class="aff__fit-comparison-dog-name">' + escapeHtml(name) + '</strong><p>' + escapeHtml(variant) + '</p></div>' +
            '<button class="aff__fit-comparison-toggle" type="button" data-aff-comparison-toggle aria-expanded="false" aria-controls="' + detailsId + '">Read more <span aria-hidden="true">⌄</span></button>' +
          '</div>' +
          '<div class="aff__fit-comparison-details" id="' + detailsId + '" data-aff-comparison-details hidden>' +
            (meta ? '<p class="aff__fit-comparison-meta">' + escapeHtml(meta) + '</p>' : '') +
            communitySocialMarkup(item, 'aff__community-social aff__community-social--comparison') +
            comparisonDetails +
            '<button class="aff__fit-comparison-view" type="button" data-aff-comparison-open>View ' + escapeHtml(name) + '’s photos <span aria-hidden="true">↗</span></button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    grid.querySelectorAll('[data-aff-comparison-card]').forEach((card) => {
      const item = matches[Number.parseInt(card.dataset.affComparisonIndex, 10) || 0];
      const toggle = card.querySelector('[data-aff-comparison-toggle]');
      const details = card.querySelector('[data-aff-comparison-details]');
      if (toggle && details) {
        toggle.addEventListener('click', () => {
          const opening = toggle.getAttribute('aria-expanded') !== 'true';
          grid.querySelectorAll('[data-aff-comparison-card]').forEach((otherCard) => {
            const otherToggle = otherCard.querySelector('[data-aff-comparison-toggle]');
            const otherDetails = otherCard.querySelector('[data-aff-comparison-details]');
            if (!otherToggle || !otherDetails || otherCard === card) return;
            otherToggle.setAttribute('aria-expanded', 'false');
            otherToggle.innerHTML = 'Read more <span aria-hidden="true">⌄</span>';
            otherDetails.hidden = true;
            otherCard.classList.remove('is-expanded');
          });
          toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
          toggle.innerHTML = (opening ? 'Show less ' : 'Read more ') + '<span aria-hidden="true">⌄</span>';
          details.hidden = !opening;
          card.classList.toggle('is-expanded', opening);
          if (opening) recordAnalyticsEvent('fit_comparison_expand', { dogKey: item.dogKey, matchPercentage: item.matchPercentage, recommendedSize: best.size, referenceSize: item.size });
        });
      }
      card.querySelectorAll('[data-aff-comparison-open]').forEach((button) => {
        button.addEventListener('click', () => {
          recordAnalyticsEvent('fit_comparison_open', { dogKey: item.dogKey, matchPercentage: item.matchPercentage, recommendedSize: best.size, referenceSize: item.size });
          openGalleryLightbox(item, 0, button, chart);
        });
      });
    });

    const galleryButton = root.querySelector('[data-aff-comparison-see-gallery]');
    if (galleryButton) {
      galleryButton.onclick = () => {
        const gallery = root.querySelector('[data-aff-fit-gallery]');
        if (!gallery || gallery.hidden) return;
        recordAnalyticsEvent('fit_comparison_gallery', { recommendedSize: best.size, matchesShown: matches.length });
        gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
    }

    section.hidden = false;
  }


  const galleryLightbox = root.querySelector('[data-aff-gallery-lightbox]');
  const lightboxImage = root.querySelector('[data-aff-lightbox-image]');
  const lightboxPan = root.querySelector('[data-aff-lightbox-pan]');
  const lightboxCounter = root.querySelector('[data-aff-lightbox-counter]');
  const lightboxName = root.querySelector('[data-aff-lightbox-name]');
  const lightboxSocial = root.querySelector('[data-aff-lightbox-social]');
  const lightboxMeta = root.querySelector('[data-aff-lightbox-meta]');
  const lightboxVariant = root.querySelector('[data-aff-lightbox-variant]');
  const lightboxDetails = root.querySelector('[data-aff-lightbox-details]');
  const lightboxPrev = root.querySelector('[data-aff-lightbox-prev]');
  const lightboxNext = root.querySelector('[data-aff-lightbox-next]');
  const lightboxPointers = new Map();
  let lightboxDog = null;
  let lightboxChart = null;
  let lightboxIndex = 0;
  let lightboxScale = 1;
  let lightboxX = 0;
  let lightboxY = 0;
  let lightboxStartX = 0;
  let lightboxStartY = 0;
  let lightboxStartPanX = 0;
  let lightboxStartPanY = 0;
  let lightboxPinchDistance = 0;
  let lightboxPinchScale = 1;
  let lightboxLastTap = 0;
  let lightboxGestureWasPinch = false;
  let lightboxTrigger = null;
  let lightboxBodyOverflow = '';

  function clampGalleryPan() {
    if (!lightboxPan || !lightboxImage) return;
    const maxX = Math.max(0, ((lightboxImage.offsetWidth * lightboxScale) - lightboxPan.clientWidth) / 2);
    const maxY = Math.max(0, ((lightboxImage.offsetHeight * lightboxScale) - lightboxPan.clientHeight) / 2);
    lightboxX = Math.max(-maxX, Math.min(maxX, lightboxX));
    lightboxY = Math.max(-maxY, Math.min(maxY, lightboxY));
  }

  function applyGalleryTransform() {
    if (!lightboxImage) return;
    clampGalleryPan();
    lightboxImage.style.transform = 'translate3d(' + lightboxX + 'px,' + lightboxY + 'px,0) scale(' + lightboxScale + ')';
    lightboxImage.classList.toggle('is-zoomed', lightboxScale > 1.01);
  }

  function resetGalleryZoom() {
    lightboxScale = 1;
    lightboxX = 0;
    lightboxY = 0;
    applyGalleryTransform();
  }

  function setGalleryZoom(nextScale) {
    lightboxScale = Math.max(1, Math.min(4, nextScale));
    if (lightboxScale === 1) {
      lightboxX = 0;
      lightboxY = 0;
    }
    applyGalleryTransform();
  }

  function renderGalleryLightboxPhoto() {
    if (!lightboxDog || !lightboxChart || !galleryLightbox) return;
    const photos = lightboxDog.photos || [lightboxDog];
    lightboxIndex = Math.max(0, Math.min(photos.length - 1, lightboxIndex));
    const photo = photos[lightboxIndex];
    const name = lightboxDog.dogName || 'ALTOFF dog';
    const metadata = [];
    const breedLabel = communityBreedLabel(lightboxDog);
    if (breedLabel) metadata.push(breedLabel);
    if (numericGalleryValue(lightboxDog.weight) != null) metadata.push(numericGalleryValue(lightboxDog.weight) + ' kg');
    const variant = ['Size ' + lightboxDog.size, photo.colour || lightboxDog.colour].filter(Boolean).join(' · ');

    resetGalleryZoom();
    lightboxImage.src = photo.imageLarge || photo.image;
    lightboxImage.alt = name + ' wearing ' + lightboxChart.shortName + ' in size ' + lightboxDog.size + (photos.length > 1 ? ', photo ' + (lightboxIndex + 1) : '');
    lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + photos.length;
    lightboxName.textContent = name;
    lightboxMeta.textContent = metadata.join(' · ');
    lightboxMeta.hidden = !metadata.length;
    if (lightboxDetails) {
      const details = [];
      if (numericGalleryValue(lightboxDog.back) != null) details.push('<span><small>Back</small><strong>' + numericGalleryValue(lightboxDog.back) + ' cm</strong></span>');
      if (numericGalleryValue(lightboxDog.chest) != null) details.push('<span><small>Chest</small><strong>' + numericGalleryValue(lightboxDog.chest) + ' cm</strong></span>');
      if (numericGalleryValue(lightboxDog.neck) != null) details.push('<span><small>Neck</small><strong>' + numericGalleryValue(lightboxDog.neck) + ' cm</strong></span>');
      lightboxDetails.innerHTML = details.join('');
      lightboxDetails.hidden = !details.length;
    }
    if (lightboxSocial) lightboxSocial.innerHTML = communitySocialMarkup(lightboxDog, 'aff__community-social aff__community-social--lightbox');
    lightboxVariant.textContent = [lightboxChart.shortName, variant].filter(Boolean).join(' · ');
    const hasMultiple = photos.length > 1;
    lightboxPrev.hidden = !hasMultiple;
    lightboxNext.hidden = !hasMultiple;
    const lightboxDialog = galleryLightbox.querySelector('.aff__gallery-lightbox-dialog');
    if (lightboxDialog) lightboxDialog.scrollTop = 0;
  }

  function changeGalleryLightboxPhoto(direction) {
    if (!lightboxDog) return;
    const photos = lightboxDog.photos || [lightboxDog];
    if (photos.length < 2) return;
    lightboxIndex = (lightboxIndex + direction + photos.length) % photos.length;
    renderGalleryLightboxPhoto();
  }

  function openGalleryLightbox(dog, index, trigger, chart) {
    if (!galleryLightbox || !lightboxImage) return;
    lightboxDog = dog;
    lightboxChart = chart;
    lightboxIndex = index || 0;
    lightboxTrigger = trigger || null;
    renderGalleryLightboxPhoto();
    galleryLightbox.hidden = false;
    galleryLightbox.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => galleryLightbox.classList.add('is-open'));
    lightboxBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    root.classList.add('is-gallery-lightbox-open');
    root.querySelector('[data-aff-lightbox-close]:not(.aff__gallery-lightbox-backdrop)').focus();
  }

  function closeGalleryLightbox() {
    if (!galleryLightbox || galleryLightbox.hidden) return;
    galleryLightbox.classList.remove('is-open');
    galleryLightbox.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-gallery-lightbox-open');
    document.body.style.overflow = lightboxBodyOverflow;
    window.setTimeout(() => {
      galleryLightbox.hidden = true;
      lightboxImage.removeAttribute('src');
      lightboxDog = null;
      lightboxPointers.clear();
      resetGalleryZoom();
      if (lightboxTrigger && document.contains(lightboxTrigger)) lightboxTrigger.focus();
      lightboxTrigger = null;
    }, 180);
  }

  function galleryPointerDistance() {
    const points = Array.from(lightboxPointers.values());
    if (points.length < 2) return 0;
    return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
  }

  if (galleryLightbox && lightboxPan) {
    root.querySelectorAll('[data-aff-lightbox-close]').forEach((button) => button.addEventListener('click', closeGalleryLightbox));
    lightboxPrev.addEventListener('click', () => changeGalleryLightboxPhoto(-1));
    lightboxNext.addEventListener('click', () => changeGalleryLightboxPhoto(1));

    lightboxPan.addEventListener('wheel', (event) => {
      event.preventDefault();
      setGalleryZoom(lightboxScale + (event.deltaY < 0 ? 0.25 : -0.25));
    }, { passive: false });

    lightboxPan.addEventListener('pointerdown', (event) => {
      lightboxPan.setPointerCapture(event.pointerId);
      lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      lightboxStartX = event.clientX;
      lightboxStartY = event.clientY;
      lightboxStartPanX = lightboxX;
      lightboxStartPanY = lightboxY;
      if (lightboxPointers.size === 2) {
        lightboxGestureWasPinch = true;
        lightboxPinchDistance = galleryPointerDistance();
        lightboxPinchScale = lightboxScale;
      }
    });

    lightboxPan.addEventListener('pointermove', (event) => {
      if (!lightboxPointers.has(event.pointerId)) return;
      lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (lightboxPointers.size >= 2) {
        const distance = galleryPointerDistance();
        if (lightboxPinchDistance) setGalleryZoom(lightboxPinchScale * (distance / lightboxPinchDistance));
        return;
      }
      if (lightboxScale > 1.01) {
        lightboxX = lightboxStartPanX + (event.clientX - lightboxStartX);
        lightboxY = lightboxStartPanY + (event.clientY - lightboxStartY);
        applyGalleryTransform();
      }
    });

    const finishGalleryPointer = (event) => {
      const startX = lightboxStartX;
      const startY = lightboxStartY;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const wasSinglePointer = lightboxPointers.size === 1;
      const wasPinch = lightboxGestureWasPinch;
      lightboxPointers.delete(event.pointerId);

      if (!wasPinch && wasSinglePointer && lightboxScale <= 1.01 && Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
        changeGalleryLightboxPhoto(deltaX < 0 ? 1 : -1);
      } else if (!wasPinch && wasSinglePointer && Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) {
        const now = Date.now();
        if (now - lightboxLastTap < 300) {
          setGalleryZoom(lightboxScale > 1.01 ? 1 : 2.5);
          lightboxLastTap = 0;
        } else {
          lightboxLastTap = now;
        }
      }

      if (!lightboxPointers.size) {
        lightboxGestureWasPinch = false;
        lightboxPinchDistance = 0;
      }
    };

    lightboxPan.addEventListener('pointerup', finishGalleryPointer);
    lightboxPan.addEventListener('pointercancel', (event) => {
      lightboxPointers.delete(event.pointerId);
      if (!lightboxPointers.size) {
        lightboxGestureWasPinch = false;
        lightboxPinchDistance = 0;
      }
    });
    window.addEventListener('resize', applyGalleryTransform, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (galleryLightbox.hidden) return;
      if (event.key === 'Escape') closeGalleryLightbox();
      if (event.key === 'ArrowLeft') changeGalleryLightboxPhoto(-1);
      if (event.key === 'ArrowRight') changeGalleryLightboxPhoto(1);
    });
  }

  function renderFitGallery(chart, best, measurements) {
    const section = root.querySelector('[data-aff-fit-gallery]');
    const track = root.querySelector('[data-aff-fit-gallery-track]');
    if (!section || !track) return;

    const preferredColour = Object.values(state.optionSelections || {}).find((value) => value && normalizeSize(value) !== normalizeSize(best.size)) || '';
    const allMatches = galleryDogs(state.product, { includeUnmapped: true })
      .map((item) => ({
        ...item,
        similarityScore: gallerySimilarityScore(item, best.size, measurements),
        colourMatch: preferredColour && item.photos.some((photo) => String(photo.colour || '').toLowerCase() === String(preferredColour).toLowerCase()) ? 1 : 0
      }))
      .sort((a, b) => (b.colourMatch - a.colourMatch) || (a.similarityScore - b.similarityScore));
    const matches = allMatches.slice(0, state.galleryVisibleCount || 4);

    if (!matches.length) {
      section.hidden = true;
      track.innerHTML = '';
      return;
    }

    const exactSizeCount = matches.filter((item) => normalizeSize(item.size) === normalizeSize(best.size)).length;
    root.querySelector('[data-aff-fit-gallery-title]').textContent = exactSizeCount
      ? 'See dogs wearing Size ' + best.size
      : 'See ' + chart.shortName + ' on real dogs';
    root.querySelector('[data-aff-fit-gallery-copy]').textContent = exactSizeCount
      ? 'Real ALTOFF dogs with the same recommended size, ranked by the measurements available.'
      : 'Real-life references for how ' + chart.shortName + ' looks across different builds.';
    root.querySelector('[data-aff-fit-gallery-count]').textContent = allMatches.length + (allMatches.length === 1 ? ' dog' : ' dogs');

    track.innerHTML = matches.map((item) => {
      const name = item.dogName || 'ALTOFF dog';
      const metadata = [];
      const breedLabel = communityBreedLabel(item);
      if (breedLabel) metadata.push(breedLabel);
      if (numericGalleryValue(item.weight) != null) metadata.push(numericGalleryValue(item.weight) + ' kg');
      const measurementsList = [];
      if (numericGalleryValue(item.back) != null) measurementsList.push('Back ' + numericGalleryValue(item.back) + ' cm');
      if (numericGalleryValue(item.chest) != null) measurementsList.push('Chest ' + numericGalleryValue(item.chest) + ' cm');
      if (numericGalleryValue(item.neck) != null) measurementsList.push('Neck ' + numericGalleryValue(item.neck) + ' cm');
      const variant = ['Size ' + item.size, item.colour].filter(Boolean).join(' · ');
      const photos = item.photos || [item];
      const slides = photos.map((photo, index) =>
        '<button class="aff__fit-dog-slide aff__gallery-open" type="button" data-aff-gallery-slide data-aff-gallery-open data-aff-photo-index="' + index + '" aria-label="Open full-size photo ' + (index + 1) + ' of ' + photos.length + ' of ' + escapeHtml(name) + '">' +
          '<img src="' + escapeHtml(photo.image) + '" alt="' + escapeHtml(name + ' wearing ' + chart.shortName + ' in size ' + item.size + (photos.length > 1 ? ', photo ' + (index + 1) : '')) + '" loading="lazy">' +
          '<span class="aff__gallery-expand" aria-hidden="true">Expand</span>' +
        '</button>'
      ).join('');
      const controls = photos.length > 1
        ? '<button class="aff__gallery-arrow aff__gallery-arrow--prev" type="button" data-aff-gallery-prev aria-label="Previous photo">‹</button>' +
          '<button class="aff__gallery-arrow aff__gallery-arrow--next" type="button" data-aff-gallery-next aria-label="Next photo">›</button>' +
          '<span class="aff__gallery-counter" data-aff-gallery-counter>1 / ' + photos.length + '</span>'
        : '';

      return '<article class="aff__fit-dog-card" data-aff-gallery-card>' +
        '<div class="aff__fit-dog-image">' +
          '<div class="aff__fit-dog-slides" data-aff-gallery-slides>' + slides + '</div>' + controls +
        '</div>' +
        '<div class="aff__fit-dog-copy">' +
          '<div class="aff__fit-dog-title"><strong>' + escapeHtml(name) + '</strong><span>' + escapeHtml(variant) + '</span></div>' +
          (metadata.length ? '<p class="aff__fit-dog-meta">' + escapeHtml(metadata.join(' · ')) + '</p>' : '') +
          (measurementsList.length ? '<p class="aff__fit-dog-measurements">' + escapeHtml(measurementsList.join(' · ')) + '</p>' : '') +
          communitySocialMarkup(item, 'aff__community-social aff__community-social--gallery') +
          (item.activityTag ? '<p class="aff__fit-dog-activity">' + escapeHtml(item.activityTag) + '</p>' : '') +
          (item.caption ? '<p class="aff__fit-dog-note">“' + escapeHtml(item.caption) + '”</p>' : '') +
        '</div>' +
      '</article>';
    }).join('');

    track.querySelectorAll('[data-aff-gallery-card]').forEach((card, cardIndex) => {
      const slides = card.querySelector('[data-aff-gallery-slides]');
      const counter = card.querySelector('[data-aff-gallery-counter]');
      const slideCount = card.querySelectorAll('[data-aff-gallery-slide]').length;
      const galleryItem = matches[cardIndex];
      card.querySelectorAll('[data-aff-gallery-open]').forEach((button) => {
        button.addEventListener('click', () => openGalleryLightbox(galleryItem, Number(button.dataset.affPhotoIndex) || 0, button, chart));
      });
      if (!slides || slideCount < 2) return;
      const updateCounter = () => {
        const index = Math.max(0, Math.min(slideCount - 1, Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth))));
        if (counter) counter.textContent = (index + 1) + ' / ' + slideCount;
      };
      card.querySelector('[data-aff-gallery-prev]').addEventListener('click', () => slides.scrollBy({ left: -slides.clientWidth, behavior: 'smooth' }));
      card.querySelector('[data-aff-gallery-next]').addEventListener('click', () => slides.scrollBy({ left: slides.clientWidth, behavior: 'smooth' }));
      slides.addEventListener('scroll', updateCounter, { passive: true });
    });

    const moreButton = root.querySelector('[data-aff-fit-gallery-more]');
    if (moreButton) {
      const remaining = Math.max(0, allMatches.length - matches.length);
      moreButton.hidden = remaining === 0;
      moreButton.textContent = remaining > 0 ? 'Load more dogs (' + remaining + ')' : 'All dogs shown';
      moreButton.onclick = remaining > 0 ? () => {
        state.galleryVisibleCount = Math.min(allMatches.length, (state.galleryVisibleCount || 4) + 4);
        renderFitGallery(chart, best, measurements);
      } : null;
    }
    section.hidden = false;
  }

  function calculate() {
    const enteredMeasurements = currentMeasurements();
    const back = enteredMeasurements.back;
    const chest = enteredMeasurements.chest;
    const neck = enteredMeasurements.neck;

    if (!back || !chest || !neck) {
      alert('Please enter back length, chest, and neck measurements.');
      return;
    }

    const chart = productConfigs[state.product];
    if (!chart || configErrors[state.product]) {
      alert('This product is not configured correctly yet. Please contact ALTOFF for sizing help.');
      return;
    }

    const measurements = { back, chest, neck };
    const preferenceInput = root.querySelector('input[name="aff-fit"]:checked');
    const preference = preferenceInput ? preferenceInput.value : chart.defaultFitPreference;
    let best;

    if (chart.recommendationStrategy === 'primary-range') {
      best = findByPrimary(chart, measurements[chart.primaryMeasurement], preference);
    } else if (chart.recommendationStrategy === 'weighted-priority') {
      best = weightedPriorityRecommend(chart, measurements);
    } else {
      console.error('ALTOFF Fit Finder: unsupported recommendation strategy:', chart.recommendationStrategy);
      alert('This product sizing method is not available yet. Please contact ALTOFF for help.');
      return;
    }

    const methodCopy = chart.methodCopy && chart.methodCopy[preference]
      ? chart.methodCopy[preference]
      : chart.methodCopy.default;

    state.recommendation = best;
    state.measurements = measurements;

    const recommendationToggle = root.querySelector('[data-aff-recommendation-toggle]');
    const recommendationDetails = root.querySelector('[data-aff-recommendation-details]');
    if (recommendationToggle && recommendationDetails) {
      recommendationToggle.setAttribute('aria-expanded', 'false');
      recommendationToggle.firstChild.textContent = 'View fit details ';
      recommendationDetails.hidden = true;
    }

    root.querySelector('[data-aff-result-size]').textContent = best.size;
    root.querySelector('[data-aff-result-product]').textContent = 'For the ' + chart.name + ', size ' + best.size + ' provides the strongest overall match.';
    root.querySelector('[data-aff-result-measurements]').innerHTML = ['back', 'chest', 'neck'].map((key) =>
      '<span><strong>' + escapeHtml(String(measurements[key])) + ' cm</strong>' + escapeHtml(measurementLabels[key]) + '</span>'
    ).join('');
    root.querySelector('[data-aff-result-highlights]').innerHTML = (chart.resultHighlights || []).map((item) =>
      '<div><span aria-hidden="true">✓</span><p>' + escapeHtml(item) + '</p></div>'
    ).join('');
    root.querySelector('[data-aff-exchange-title]').textContent = chart.exchangeTitle || 'Fit support included';
    root.querySelector('[data-aff-exchange-copy]').textContent = chart.exchangeCopy || 'Contact us if you need help confirming the fit.';

    const productLink = root.querySelector('[data-aff-product-link]');
    const selectedProduct = productData[state.product];
    if (selectedProduct && selectedProduct.url) {
      productLink.href = selectedProduct.url;
      productLink.hidden = false;
    } else {
      productLink.hidden = true;
      productLink.removeAttribute('href');
    }

    const insights = recommendationInsights(chart, best, measurements);
    const confidence = insights.confidence;
    const galleryMatchCount = galleryDogs(state.product).length;
    currentAudit = {
      productName: chart.name,
      strategy: chart.recommendationStrategy,
      primaryMeasurement: measurementLabels[chart.primaryMeasurement],
      confidenceScore: insights.confidenceScore,
      confidenceLabel: confidence.label,
      alternative: insights.alternative ? insights.alternative.size : null,
      galleryMatches: galleryMatchCount,
      decisionPath: [measurementLabels[chart.primaryMeasurement] + ' assessed', 'Size ' + best.size + ' selected', insights.limitingLabel + ' limiting', confidence.label]
    };
    recordAnalyticsEvent('recommendation', {
      measurements: { ...measurements },
      recommendedSize: best.size,
      confidenceScore: insights.confidenceScore,
      confidenceLabel: confidence.label,
      fitPreference: preference || chart.defaultFitPreference || null,
      limitingMeasurement: insights.limitingKey
    });
    const confidenceEl = root.querySelector('[data-aff-confidence]');
    confidenceEl.textContent = confidence.label;
    confidenceEl.className = 'aff__confidence ' + confidence.className;
    root.querySelector('[data-aff-limiting]').textContent = insights.limitingLabel;
    root.querySelector('[data-aff-confidence-score]').textContent = insights.confidenceScore + '%';
    const confidenceBar = root.querySelector('[data-aff-confidence-bar]');
    confidenceBar.style.width = '0%';
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => { confidenceBar.style.width = insights.confidenceScore + '%'; }));

    const why = [
      { tone: 'info', text: methodCopy },
      explanation('Back length', back, best.backMin, best.backMax),
      explanation('Chest', chest, best.chestMin, best.chestMax),
      explanation('Neck', neck, best.neckMin, best.neckMax)
    ];
    root.querySelector('[data-aff-why]').innerHTML = why
      .map((item) => '<div class="is-' + item.tone + '"><span aria-hidden="true">' + (item.tone === 'good' ? '✓' : '•') + '</span><p>' + escapeHtml(item.text) + '</p></div>')
      .join('');

    root.querySelector('[data-aff-breakdown]').innerHTML = ['back', 'chest', 'neck'].map((key) => {
      const item = insights.assessments[key];
      return '<div class="aff__measurement-row"><span>' + insights.labels[key] + '</span><strong class="is-' + item.status + '">' + item.label + '</strong></div>';
    }).join('');

    const fitPreference = preference || chart.defaultFitPreference;
    const fitTraits = chart.fitTraits[fitPreference] || chart.fitTraits.default || [];
    root.querySelector('[data-aff-fit-summary]').innerHTML = '<strong>Expected fit</strong><div>' + fitTraits.map((trait) => '<span>✓ ' + escapeHtml(trait) + '</span>').join('') + '</div>';

    const between = root.querySelector('[data-aff-between]');
    if (insights.alternative) {
      const alternativeIsLarger = chart.sizes.findIndex((size) => size.size === insights.alternative.size) > chart.sizes.findIndex((size) => size.size === best.size);
      between.hidden = false;
      between.innerHTML = '<div><span>Recommended</span><strong>Size ' + escapeHtml(best.size) + '</strong><p>' + (alternativeIsLarger ? 'Closer, more athletic fit.' : 'More room and coverage.') + '</p></div>' +
        '<div><span>Alternative</span><strong>Size ' + escapeHtml(insights.alternative.size) + '</strong><p>' + (alternativeIsLarger ? 'More relaxed with extra room.' : 'Closer fit with less room.') + '</p></div>';
    } else {
      between.hidden = true;
      between.innerHTML = '';
    }

    const borderline = root.querySelector('[data-aff-borderline]');
    if (confidence.className === 'is-borderline') {
      borderline.hidden = false;
      borderline.innerHTML = '<strong>Fit check recommended</strong><p>Your dog is close to a size boundary or one measurement falls outside the selected range. Contact us before ordering if your dog has a broad chest, thick coat, or unique body shape.</p>';
    } else if (insights.alternative) {
      borderline.hidden = false;
      borderline.innerHTML = '<strong>Prefer a different fit?</strong><p>The alternative size may also work. Choose the larger size for more room or the smaller size for a closer fit.</p>';
    } else {
      borderline.hidden = true;
      borderline.innerHTML = '';
    }

    const message =
      'Hi ALTOFF!%0A%0AI used the Fit Finder.%0A%0AProduct: ' + chart.name +
      '%0ARecommended size: ' + best.size +
      '%0AConfidence: ' + confidence.label +
      '%0A%0AMeasurements:%0ABack: ' + back + 'cm%0AChest: ' + chest + 'cm%0ANeck: ' + neck +
      'cm%0A%0ACould you help me confirm the fit?';
    root.querySelector('[data-aff-whatsapp]').href = 'https://wa.me/6589252216?text=' + message;

    recordRecommendation(state.activeProfileId, chart, best, confidence, preference, measurements);
    state.galleryVisibleCount = 4;
    renderFitGallery(chart, best, measurements);
    renderFitComparison(chart, best, measurements);
    renderFitIntelligence(chart, best, measurements);
    setupPurchase();
    renderDebugAudit();
    updateProfileSaveCard();
    show('result');
  }

  root.querySelectorAll('[data-aff-next]').forEach((button) => button.addEventListener('click', () => show(button.dataset.affNext)));
  root.querySelectorAll('[data-aff-product]').forEach((button) => button.addEventListener('click', () => {
    state.product = button.dataset.affProduct;
    const selectedConfig = productConfigs[state.product];
    fitChoice.hidden = !(selectedConfig && selectedConfig.fitPreferenceEnabled);
    hideSavedSizeConflict();
    renderProfiles();
    renderSavedFitRecall();
    show('measurements');
  }));
  const recommendationToggle = root.querySelector('[data-aff-recommendation-toggle]');
  const recommendationDetails = root.querySelector('[data-aff-recommendation-details]');
  if (recommendationToggle && recommendationDetails) {
    recommendationToggle.addEventListener('click', () => {
      const willOpen = recommendationToggle.getAttribute('aria-expanded') !== 'true';
      recommendationToggle.setAttribute('aria-expanded', String(willOpen));
      recommendationDetails.hidden = !willOpen;
      recommendationToggle.firstChild.textContent = willOpen ? 'Hide fit details ' : 'View fit details ';
    });
  }

  root.querySelector('[data-aff-calculate]').addEventListener('click', calculate);
  root.querySelector('[data-aff-add-cart]').addEventListener('click', addToCart);
  root.querySelector('[data-aff-continue]').addEventListener('click', () => {
    const product = productData[state.product];
    if (product && product.url) window.location.href = product.url;
    else show('product');
  });

  resetBtn.addEventListener('click', () => {
    state = { product: null, recommendation: null, selectedVariant: null, optionSelections: {}, measurements: null, activeProfileId: null, pendingWardrobeUpdate: null };
    root.querySelector('#aff-back').value = '';
    root.querySelector('#aff-chest').value = '';
    root.querySelector('#aff-neck').value = '';
    root.querySelectorAll('[data-aff-card]').forEach((card) => card.classList.remove('is-complete'));
    show('welcome');
  });

  root.querySelector('[data-aff-saved-fit-check]').addEventListener('click', calculate);
  root.querySelector('[data-aff-saved-fit-update]').addEventListener('click', () => {
    const firstInput = root.querySelector('#aff-back');
    if (firstInput) {
      firstInput.focus();
      firstInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  root.querySelector('[data-aff-conflict-keep]').addEventListener('click', () => {
    const pending = state.pendingWardrobeUpdate;
    if (!pending) return;
    recordAnalyticsEvent('saved_size_kept', { savedSize: pending.savedSize, recommendedSize: pending.entry.size });
    hideSavedSizeConflict();
    renderPassportHistory();
  });
  root.querySelector('[data-aff-conflict-update]').addEventListener('click', () => {
    const pending = state.pendingWardrobeUpdate;
    if (!pending) return;
    saveRecommendationEntry(pending.profileId, pending.entry, pending.measurements);
    recordAnalyticsEvent('saved_size_updated', { previousSize: pending.savedSize, newSize: pending.entry.size });
    hideSavedSizeConflict();
    renderPassportHistory();
  });

  root.querySelector('[data-aff-profile-new]').addEventListener('click', () => openProfileSheet(null));
  root.querySelector('[data-aff-profile-save]').addEventListener('click', () => {
    const active = dogProfiles.find((profile) => profile.id === state.activeProfileId);
    openProfileSheet(active || null);
  });
  root.querySelector('[data-aff-profile-confirm]').addEventListener('click', saveProfileFromSheet);
  root.querySelectorAll('[data-aff-profile-close]').forEach((button) => button.addEventListener('click', closeProfileSheet));
  root.querySelector('[data-aff-profile-list]').addEventListener('click', (event) => {
    const useButton = event.target.closest('[data-aff-profile-use]');
    const editButton = event.target.closest('[data-aff-profile-edit]');
    const deleteButton = event.target.closest('[data-aff-profile-delete]');
    const id = useButton ? useButton.dataset.affProfileUse : editButton ? editButton.dataset.affProfileEdit : deleteButton ? deleteButton.dataset.affProfileDelete : null;
    if (!id) return;
    const profile = dogProfiles.find((item) => item.id === id);
    if (!profile) return;
    if (useButton) applyProfile(profile);
    if (editButton) openProfileSheet(profile);
    if (deleteButton && window.confirm('Remove ' + profile.name + ' from this device?')) {
      dogProfiles = dogProfiles.filter((item) => item.id !== id);
      if (state.activeProfileId === id) state.activeProfileId = null;
      persistDogProfiles();
      renderProfiles();
      updateProfileSaveCard();
    }
  });
  root.querySelector('[data-aff-profile-name]').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') saveProfileFromSheet();
  });
  renderProfiles();

  const guideSheet = root.querySelector('[data-aff-guide-sheet]');
  const guideBackdrop = root.querySelector('.aff__guide-backdrop');
  const guideTitle = root.querySelector('[data-aff-guide-title]');
  const guideCopy = root.querySelector('[data-aff-guide-copy]');
  const guidePrev = root.querySelector('[data-aff-guide-prev]');
  const guideNext = root.querySelector('[data-aff-guide-next]');
  const guideImage = root.querySelector('[data-aff-guide-image]');
  const guidePlaceholder = root.querySelector('[data-aff-guide-placeholder]');
  const guideAssetsNode = root.querySelector('[data-aff-guide-assets]');
  let guideAssets = {};
  try { guideAssets = guideAssetsNode ? JSON.parse(guideAssetsNode.textContent) : {}; } catch (error) { guideAssets = {}; }
  const guideOrder = ['back', 'chest', 'neck'];
  const guideData = {
    back: { title: 'Back length', copy: 'Measure from the base of the neck to the base of the tail.' },
    chest: { title: 'Chest circumference', copy: 'Measure around the widest part of the chest, just behind the front legs.' },
    neck: { title: 'Neck circumference', copy: 'Measure around the base of the neck where the collar naturally sits.' }
  };
  let activeGuide = 'back';

  function renderGuide(type) {
    activeGuide = type;
    const data = guideData[type];
    guideTitle.textContent = data.title;
    guideCopy.textContent = data.copy;
    root.querySelectorAll('[data-aff-guide-tab]').forEach((button) => button.classList.toggle('is-active', button.dataset.affGuideTab === type));

    const productGuides = guideAssets[state.product] || {};
    const imageUrl = productGuides[type] || null;
    if (imageUrl) {
      guideImage.src = imageUrl;
      guideImage.alt = data.title + ' measurement guide';
      guideImage.hidden = false;
      guidePlaceholder.hidden = true;
    } else {
      guideImage.removeAttribute('src');
      guideImage.alt = '';
      guideImage.hidden = true;
      guidePlaceholder.hidden = false;
      const productName = productConfigs[state.product] ? productConfigs[state.product].shortName : 'Product';
      guidePlaceholder.querySelector('span').textContent = productName + ' ' + data.title;
    }

    const index = guideOrder.indexOf(type);
    guidePrev.disabled = index === 0;
    guideNext.textContent = index === guideOrder.length - 1 ? 'Got it' : 'Next';
  }

  function openGuide(type) {
    renderGuide(type);
    guideSheet.classList.add('is-open');
    guideBackdrop.classList.add('is-open');
    guideSheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeGuide() {
    guideSheet.classList.remove('is-open');
    guideBackdrop.classList.remove('is-open');
    guideSheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  root.querySelectorAll('[data-aff-guide]').forEach((button) => button.addEventListener('click', () => openGuide(button.dataset.affGuide)));
  root.querySelectorAll('[data-aff-guide-close]').forEach((button) => button.addEventListener('click', closeGuide));
  root.querySelectorAll('[data-aff-guide-tab]').forEach((button) => button.addEventListener('click', () => renderGuide(button.dataset.affGuideTab)));
  guidePrev.addEventListener('click', () => {
    const index = guideOrder.indexOf(activeGuide);
    if (index > 0) renderGuide(guideOrder[index - 1]);
  });
  guideNext.addEventListener('click', () => {
    const index = guideOrder.indexOf(activeGuide);
    if (index < guideOrder.length - 1) renderGuide(guideOrder[index + 1]);
    else closeGuide();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && guideSheet.classList.contains('is-open')) closeGuide();
  });

  ['back', 'chest', 'neck'].forEach((key) => {
    const input = root.querySelector('#aff-' + key);
    const card = root.querySelector('[data-aff-card="' + key + '"]');
    input.addEventListener('input', () => card.classList.toggle('is-complete', Number(input.value) > 0));
  });

  show('welcome', { scroll: false });
});
